import React from 'react'

const SegmentTree = () => {
  return (
    <div>
        <iframe src="https://visualgo.net/en/segmenttree" width="100%" height="920px" title="SegmentTree"></iframe>
    </div>
  )
}

export default SegmentTree